import { v4 as uuidv4 } from 'uuid';
export const GLSL1 = '100';
export const GLSL3 = '300 es';
export class Material {
    id;
    uuid;
    type;
    uniforms = {};
    vertexShader;
    fragmentShader;
    gl;
    glslVersion;
    map = null;
    alphaMap = null;
    static id = -1;
    ambient;
    diffuse;
    specular;
    specularExponent;
    constructor(parameters) {
        this.id = Material.id++;
        this.uuid = uuidv4();
        this.type = parameters?.type || 'Material';
        this.glslVersion = parameters?.glslVersion;
        this.ambient = parameters?.ambient;
        this.diffuse = parameters?.diffuse;
        this.specular = parameters?.specular;
        this.specularExponent = parameters?.specularExponent;
        this.vertexShader = '';
        this.fragmentShader = '';
    }
}
